import React, { useMemo } from "react";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import { getAntdLocale } from "util/antdLocale";

const MainLayout = ({ children }) => {
  const { i18n } = useTranslation();
  const antdLocale = useMemo(
    () => getAntdLocale(i18n.language),
    [i18n.language],
  );
  return (
    <ConfigProvider locale={antdLocale}>
      <div>{children}</div>
    </ConfigProvider>
  );
};

export default MainLayout;
